
import { Vue, Component, Prop } from "vue-property-decorator";

import UIButton from "@/components/button/ui-button.vue";
import Card from "@/components/card/Card.vue";
import TableNotesAvatar from "@/components/table/TableNotesAvatarNew.vue";
import CardBodyItem from "@/components/card/CardBodyItem.vue";
import moment from "moment";

@Component({
  components: {
    UIButton,
    Card,
    TableNotesAvatar,
    CardBodyItem,
  },
})
export default class BasicEmployeeCard extends Vue {
  @Prop({ type: String, required: true }) readonly firstName!: string;
  @Prop({ type: String, required: true }) readonly lastName!: string;
  @Prop({ type: String, default: undefined }) readonly jobTitle?: string;
  @Prop({ type: String, default: undefined }) readonly location?: string;
  @Prop({ type: String, default: undefined }) readonly avatar?: string;
  @Prop({ type: Boolean, default: true }) readonly allowActions!: boolean;
  @Prop({ type: String, default: "" }) readonly note!: string;
  @Prop({ type: String, default: undefined }) openDate?: string;

  get firstNames(): string {
    return this.firstName;
  }
  get lastNames(): string {
    return this.lastName;
  }

  get fullDate(): string {
    //@ts-ignore
    var date = new Date(this.openDate);
    return `${this.$moment(String(this.openDate)).format("DD MMMM, YYYY")}`;
    //moment(String(this.openDate)).toLocaleDateString();
  }

  get initials(): string {
    return `${this.firstName.trimStart()[0]}${this.lastName.trimStart()[0]}`;
  }

  get notes(): string {
    if (!this.note) {
      return "notes added here";
    }
    return this.note;
  }
}
